import {createAction, props} from '@ngrx/store';
import {IEntryType} from '../_interface/ientry-type';
import { Update } from '@ngrx/entity';


export const loadEntryTypes = createAction(
	'[Journal 📦 EntryTypes] Loaded 👍',
	props<{ entryTypes: IEntryType[] }>()
);

export const updateEntryType = createAction(
	'[Journal 📦 EntryTypes] Update',
	props<Update<IEntryType>>()
);

export const entryTypeUpdated = createAction(
	'[Journal 📦 EntryTypes] Update success',
	props<Update<IEntryType>>()
);

export const removeEntryType = createAction(
	'[Journal 📦 EntryTypes] Remove',
	props<{entryTypeId: string}>()
);

export const createEntryType = createAction(
	'[Journal 📦 EntryTypes] Create',
	props<{ entryType: IEntryType }>()
);

export const entryTypeCreated = createAction(
	'[Journal 📦 EntryTypes] Create success',
	props<{ entryType: IEntryType }>()
);

export const entryTypeRemoved = createAction(
	'[Journal 📦 EntryTypes] Remove success',
	props<{ entryTypeId: string }>()
);
